import { ReactNode } from 'react';

export const isIgnoredNode = (node: ReactNode) => {
  const type = typeof node;

  if (type === 'undefined' || type === 'boolean' || node === null) {
    return true;
  }

  return false;
};
